import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";

const LAB =
  "https://images.unsplash.com/photo-1773227897623-2b03be4d078f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxtZWRpY2FsJTIwbGFib3JhdG9yeSUyMGNsZWFuJTIwc2NpZW5jZSUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg2NjM0NTE3fDA&ixlib=rb-4.1.0&q=85";

const precautions = [
  "For external use only. Do not ingest.",
  "Avoid contact with eyes and mucous membranes.",
  "Discontinue use if irritation or rash develops.",
  "Not a substitute for sutures on deep or gaping wounds.",
  "Keep out of reach of children under 3 years.",
  "Store below 30°C, away from direct sunlight.",
  "Consult a physician for diabetic or infected wounds.",
  "Do not use beyond the printed expiry date.",
];

export const Precautions = () => (
  <section id="precautions" className="py-24 md:py-32 bg-muted/40" data-testid="precautions-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <div className="flex items-baseline gap-4 mb-8">
          <span className="font-serifaccent italic text-secondary text-6xl md:text-7xl leading-none">04</span>
          <div>
            <span className="font-monotech text-xs tracking-[0.25em] uppercase text-text-muted">Chapter</span>
            <h2 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-primary leading-none">
              Precautions
            </h2>
          </div>
        </div>
        <div className="rounded-3xl overflow-hidden border border-border shadow-xl">
          <img src={LAB} alt="Clinical laboratory" className="w-full h-[260px] md:h-[340px] object-cover" />
        </div>
        <div className="mt-6 flex items-start gap-3 bg-secondary/15 border border-secondary/30 rounded-2xl p-5">
          <AlertTriangle className="w-5 h-5 text-secondary-foreground shrink-0 mt-0.5" />
          <p className="text-sm text-primary leading-relaxed">
            Always read the label and enclosed leaflet before use. Perform a small patch test if
            you have sensitive skin.
          </p>
        </div>
      </div>

      <div className="lg:col-span-7 flex flex-col justify-center">
        {precautions.map((p, i) => (
          <motion.div
            key={p}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.05 }}
            className="flex items-start gap-4 border-b border-border py-4 group"
            data-testid={`precaution-${i}`}
          >
            <span className="font-monotech text-xs text-secondary-foreground/60 pt-1">
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="text-base md:text-lg text-primary font-medium group-hover:translate-x-1 transition-transform duration-300">
              {p}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
